// Get Contact Details
export const GET_CONTACT_DETAILS_REQUEST = 'GET_CONTACT_DETAILS_REQUEST';
export const GET_CONTACT_DETAILS_DONE = 'GET_CONTACT_DETAILS_DONE';
export const GET_CONTACT_DETAILS_FAILED = 'GET_CONTACT_DETAILS_FAILED';

// Change Contact Details
export const CHANGE_CONTACT_REQUEST = 'CHANGE_CONTACT_REQUEST';
export const CHANGE_CONTACT_DONE = 'CHANGE_CONTACT_DONE';
export const CHANGE_CONTACT_FAILED = 'CHANGE_CONTACT_FAILED';

// Actions
export const CLEAR_CONTACT_ERRORS = 'CLEAR_CONTACT_ERRORS';